import { WordBank } from './index';

export const techJargon: WordBank = {
  id: 'tech',
  name: 'Tech Jargon',
  description: 'Common technical terms and buzzwords in the tech industry',
  categories: ['programming', 'infrastructure', 'design', 'methodology', 'security', 'data'],
  words: [
    {
      word: "Kubernetes",
      definition: "An open-source container orchestration platform for automating deployment, scaling, and management of containerized applications",
      difficulty: "hard",
      category: "infrastructure",
      example: "We're using Kubernetes to manage our microservices deployment"
    },
    {
      word: "API",
      definition: "Application Programming Interface - a set of rules and protocols for building and interacting with software applications",
      difficulty: "easy",
      category: "programming",
      example: "The frontend communicates with the backend through a REST API"
    },
    {
      word: "DevOps",
      definition: "A set of practices combining software development (Dev) and IT operations (Ops) to shorten the development lifecycle",
      difficulty: "medium",
      category: "methodology",
      example: "Our DevOps practices have improved deployment frequency"
    },
    {
      word: "UX",
      definition: "User Experience - the overall experience of a person using a product, especially in terms of how easy or pleasing it is to use",
      difficulty: "easy",
      category: "design",
      example: "The UX of our app needs improvement"
    },
    {
      word: "Blockchain",
      definition: "A decentralized, distributed ledger technology that records transactions across multiple computers",
      difficulty: "hard",
      category: "technology",
      example: "We're using blockchain for secure transaction records"
    },
    {
      word: "Machine Learning",
      definition: "A subset of artificial intelligence that enables systems to learn and improve from experience without explicit programming",
      difficulty: "hard",
      category: "data",
      example: "The recommendation system uses machine learning algorithms"
    },
    {
      word: "Git",
      definition: "A distributed version control system for tracking changes in source code during software development",
      difficulty: "medium",
      category: "programming",
      example: "Don't forget to git pull before starting work"
    },
    {
      word: "Agile",
      definition: "An iterative approach to project management and software development that emphasizes flexibility, customer collaboration, and rapid delivery",
      difficulty: "medium",
      category: "methodology",
      example: "Our team follows agile development practices"
    },
    {
      word: "Zero-Day",
      definition: "A software vulnerability that is unknown to the software creator and can be exploited by attackers before it's patched",
      difficulty: "hard",
      category: "security",
      example: "The system was compromised through a zero-day exploit"
    },
    {
      word: "Big Data",
      definition: "Extremely large data sets that can be analyzed to reveal patterns, trends, and associations",
      difficulty: "medium",
      category: "data",
      example: "We use big data analytics to understand user behavior"
    }
  ]
}; 